import { LitElement, html, css } from '~/lib/bn-lit-element';
import { mdiFileDocumentArrowRight } from '@mdi/js';

class BnSvgIcon extends LitElement {
  static get styles() {
    return css`
      :host {
        display: inline-block;
        width: 20px;
        height: 22px;
        fill: currentColor;
        vertical-align: middle;
      }
    `;
  }

  static get properties() {
    return {
      name: { type: String },
    };
  }

  render() {
    const { viewBox, path } = this._getSvgParams(this.name);
    return html`<svg viewBox="${viewBox}"><path d="${path}"/></svg>`;
  }

  _getSvgParams(iconName) {
    switch (iconName) {
    case 'FileDocumentArrowRight':
      return { viewBox: '0 0 24 24', path: mdiFileDocumentArrowRight };
    }
  }
}

window.customElements.define('bn-svg-icon', BnSvgIcon);
